<div #messagesListContainer class="content">
  @for (message of messages; track message) {
    <div class="motivational-wrapper"
      [ngClass]="[message.get('type')]"
      [ngStyle]="{'cursor':message.get('detail') !== ''?'pointer':'default'}"
      (click)="openDetail(message, null)">
      <div [innerHTML]="message.get('body')"></div>
      @if (isMoreDetailToOpen(message)) {
        <div class="see-more">{{'generic.see_more' | translate}}</div>
      }
    </div>
  }
</div>

<div class="footer-action">
  <button aria-label="help" (click)="openHelp()" class="bem-app-feedback__footer-action__button-openHelp"  >
    {{ 'generic.help.feedback' | translate}}
  </button>
</div>
